/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import JobItemStatus from "./helpers/JobItemStatus";

const JobViewItemList = ({ job, jobItems }) => {
  const data = jobItems.map(jobItem => (
    <tr className="content" key={jobItem.id}>
      <td>{jobItem.id}</td>
      <td>{jobItem.item.description}</td>
      <td>{jobItem.item.quantity}</td>
      <td>
        <JobItemStatus job={job} jobItem={jobItem} />
      </td>
    </tr>
  ));
  return <tbody>{data}</tbody>;
};
JobViewItemList.propTypes = {
  job: PropTypes.object.isRequired,
  jobItems: PropTypes.array.isRequired
};

export default JobViewItemList;



// WEBPACK FOOTER //
// ./src/components/jobs/JobViewItemList.js